import { render } from "./AboutUs.vue?vue&type=template&id=4ddf3bf6&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=4ddf3bf6&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddf3bf6"]])

export default __exports__